<template>
    <div>
        <div>
            <div class="row mb-3">
                <search-bar v-model="searchString"
                            placeholder="Nach Namen suchen ..."></search-bar>
            </div>

            <no-data v-if="hasNoData"></no-data>

            <loader v-if="!hasNoData && isLoading"></loader>

            <leaflet v-for="(item, index) in filteredList"
                     v-if="!isLoading"
                     :key="item.id"
                     :data-index="index"
                     :item="item"></leaflet>
        </div>
    </div>
</template>

<script>
import Leaflet from './Leaflet';
import {mapGetters} from 'vuex';

export default {
    name: 'Leaflets',
    components: {Leaflet},
    data() {
        return {
            items: [],
            searchString: null,
            fetchingData: true,
            isLoading: true,
            hasNoData: false,
        };
    },
    created: function() {
        axios.get('/api/merchant/leaflets').then((response) => {
            this.items = response.data.data;
            if (response.data.data.length === 0) {
                this.hasNoData = true;
            }

            if (response.data.data.length > 0) {
                this.isLoading = false;
            }
        }).catch((errors) => {
            this.$swal({
                icon: 'error',
                title: 'Die Daten konnten nicht geladen werden',
            });
            this.isLoading = false;
            this.hasNoData = true;
        });

    },
    computed: {
        filteredList() {
            if (!this.searchString) {
                return this.items;
            }
            return this.items.filter(element => {
                return element.name.toLowerCase().includes(this.searchString.toLowerCase());
            });
        },
        ...mapGetters({
            merchantInfo: 'meinbuero/merchantInfo',
        }),
    },

    watch: {
        searchString(newValue) {
            this.searchString = newValue;
        },
    },
};
</script>
